export class IChaluka {
    ms_zehut: number;
    full_name: string;
    phone: string;
    k_sug_matana: number;
    teur_sug_matana: string;
    shem_m_chaluka: string;
    tr_kabala: string;
    ishur_kabala: number;
}